import { differenceInYears, isValid, parseISO } from 'date-fns';

/**
 * Parses an ISO date string without throwing. Returns null when the value is missing or invalid.
 */
export function parseIsoDateSafe(value: string | null | undefined): Date | null {
  if (!value?.trim()) {
    return null;
  }

  const date = parseISO(value.trim());
  return isValid(date) ? date : null;
}

export function getAgeFromIsoDate(value: string | null | undefined): number | null {
  const date = parseIsoDateSafe(value);
  if (!date) {
    return null;
  }

  const age = differenceInYears(new Date(), date);
  return Number.isFinite(age) ? age : null;
}
